const hideHelpButton = (path) => {
  const hideHelpButtonList = [
    '/login',
    '/forgot-password',
    '/host/help-request-form',
    '/host/attendance-record',
    '/forbidden-schedule',
    '/reschedule-form',
    '/host/task-submission',
  ];

  return hideHelpButtonList.some((route) => path.startsWith(route));
};

export default hideHelpButton;
